/**
 * Pure helpers for the {@link DataTable} column-sort cycle (kept out of the
 * component file so React Fast Refresh only sees component exports there).
 */

/**
 * Cycle a column's sort state for the DRF `ordering` param: unsorted → ascending
 * (`key`) → descending (`-key`) → back to a caller-chosen default.
 */
export function nextOrdering(current: string, sortKey: string, fallback = ''): string {
  if (current === sortKey) return `-${sortKey}`
  if (current === `-${sortKey}`) return fallback
  return sortKey
}

/** The sort direction currently applied to `sortKey`, or null if not the sort column. */
export function sortDirection(current: string, sortKey: string): 'asc' | 'desc' | null {
  if (current === sortKey) return 'asc'
  if (current === `-${sortKey}`) return 'desc'
  return null
}
